import { useSelector } from "react-redux";
import { RootState } from "store";
import { MasterData } from "@spike/masterdata-model";

export const useMasterData = (): MasterData => {
	const masterData = useSelector<RootState, MasterData>(state => state.masterData.data);
  return masterData;
};

export default useMasterData;